import { render, staticRenderFns } from "./VideoDelete.vue?vue&type=template&id=e877dbc0&"
import script from "./VideoDelete.vue?vue&type=script&lang=js&"
export * from "./VideoDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./VideoDelete.vue?vue&type=custom&index=0&blockType=i18nf"
if (typeof block0 === 'function') block0(component)

export default component.exports